import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllStorage } from '../../utils/commonAuthUtils';
import { updateServiceWorker } from '../../serviceWorkerRegistration';

const ClearCacheLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      // Clear caches
      if ('caches' in window) {
        const cacheNames = await caches?.keys();
        await Promise.all(cacheNames?.map((cache) => caches?.delete(cache)));
      }

      // Clear localStorage and sessionStorage completely (including accountId and forceNormalAuth)
      clearAllStorage();
      updateServiceWorker();
      navigate('/account', { replace: true });
    })();
  }, [navigate]);

  return <div>Logging out and clearing cache...</div>;
};

export default ClearCacheLogout;
